var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/add-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9837 5.26303V5.26383V10.1813C12.9837 11.1909 12.6839 11.9615 12.166 12.4795C11.648 12.9974 10.8774 13.2972 9.86778 13.2972H4.95622C3.94658 13.2972 3.17604 12.9974 2.65815 12.4789C2.14022 11.9603 1.84028 11.1882 1.84028 10.1754V5.26383C1.84028 4.2542 2.14009 3.48357 2.65802 2.96564C3.17595 2.44771 3.94658 2.14789 4.95622 2.14789H9.87365C10.8833 2.14789 11.6538 2.44774 12.171 2.96551C12.688 3.48322 12.9865 4.25358 12.9837 5.26303ZM8.14844 10.0698V8.45605H9.76215C10.1648 8.45605 10.4957 8.12518 10.4957 7.72255C10.4957 7.31992 10.1648 6.98904 9.76215 6.98904H8.14844V5.37533C8.14844 4.97269 7.81756 4.64182 7.41493 4.64182C7.0123 4.64182 6.68142 4.97269 6.68142 5.37533V6.98904H5.06771C4.66508 6.98904 4.3342 7.31992 4.3342 7.72255C4.3342 8.12518 4.66508 8.45605 5.06771 8.45605H6.68142V10.0698C6.68142 10.4724 7.0123 10.8033 7.41493 10.8033C7.81756 10.8033 8.14844 10.4724 8.14844 10.0698Z",
    fill: "#92ABFE",
    stroke: "#92ABFE",
    strokeWidth: 0.586806
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquare);
export default __webpack_public_path__ + "static/media/add-square.c222a6b7668e4ebf2eaea3e36406aeb8.svg";
export { ForwardRef as ReactComponent };